import { useRouter } from "next/router";
import { teamConfigs } from "../config/teamConfigs";
import { TeamConfig as BaseTeamConfig } from "../config/teamConfigs/types";

export type TeamConfig = BaseTeamConfig;

export function useTeamConfig(): TeamConfig {
  const router = useRouter();
  const teamSchema = router.query.teamSchema as string;
  const teamConfig = teamConfigs.find((itm) => {
    return itm.teamSchema == teamSchema;
  });

  if (teamConfig) {
    return teamConfig;
  } else {
    // push 404 if necessary
    return null as unknown as TeamConfig;
  }
}
